export const ten_frame_formations_0 = [
  [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ]
];

export const ten_frame_formations_1 = [
  [
    [1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ],
];

export const ten_frame_formations_2 = [
  [
    [1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ],
  [
    [1, 0, 0, 0, 0],
    [1, 0, 0, 0, 0],
  ],
];

export const ten_frame_formations_3 = [
  [
    [1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0],
  ],
  [
    [1, 1, 0, 0, 0],
    [1, 0, 0, 0, 0],
  ],
];

export const ten_frame_formations_4 = [
  [
    [1, 1, 1, 1, 0],
    [0, 0, 0, 0, 0],
  ],
  [
    [1, 1, 0, 0, 0],
    [1, 1, 0, 0, 0],
  ],
];

export const ten_frame_formations_5 = [
  [
    [1, 1, 1, 1, 1],
    [0, 0, 0, 0, 0],
  ],
  [
    [1, 1, 1, 0, 0],
    [1, 1, 0, 0, 0],
  ],
];

export const ten_frame_formations_6 = [
  [
    [1, 1, 1, 1, 1],
    [1, 0, 0, 0, 0],
  ],
  [
    [1, 1, 1, 0, 0],
    [1, 1, 1, 0, 0],
  ],
];

export const ten_frame_formations_7 = [
  [
    [1, 1, 1, 1, 1],
    [1, 1, 0, 0, 0],
  ],
  [
    [1, 1, 1, 1, 0],
    [1, 1, 1, 0, 0],
  ],
];

export const ten_frame_formations_8 = [
  [
    [1, 1, 1, 1, 1],
    [1, 1, 1, 0, 0],
  ],
  [
    [1, 1, 1, 1, 0],
    [1, 1, 1, 1, 0],
  ],
];

export const ten_frame_formations_9 = [
  [
    [1, 1, 1, 1, 1],
    [1, 1, 1, 1, 0],
  ],
  [
    [1, 1, 1, 1, 1],
    [1, 1, 1, 1, 0],
  ],
];

export const ten_frame_formations_10 = [
  [
    [1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1],
  ],
];

export const ten_frame_formations = [
  ten_frame_formations_0,
  ten_frame_formations_1,
  ten_frame_formations_2,
  ten_frame_formations_3,
  ten_frame_formations_4,
  ten_frame_formations_5,
  ten_frame_formations_6,
  ten_frame_formations_7,
  ten_frame_formations_8,
  ten_frame_formations_9,
  ten_frame_formations_10,
];
